export default __webpack_public_path__ + "static/media/Manual.750df520.pdf";